<div #wgChartContainer class="weather-graph-chart-container">
    <highcharts-chart *ngIf="chartOptions"  [Highcharts]="Highcharts" [options]="chartOptions">
    </highcharts-chart>
</div>
